export interface SequelIdentityInput {
  ownerUid: string;
  sourceProjectId: string;
  targetVolume: number;
  seriesId?: string;
}

/** Browser-safe deterministic digest (no Node crypto). */
function stableDigest(material: string, hexLen: number): string {
  let h1 = 0x811c9dc5;
  let h2 = 0x9e3779b9;
  for (let i = 0; i < material.length; i++) {
    const c = material.charCodeAt(i);
    h1 ^= c;
    h1 = Math.imul(h1, 0x01000193);
    h2 = (h2 + Math.imul(c, i + 1)) >>> 0;
  }
  const combined = `${(h1 >>> 0).toString(16).padStart(8, '0')}${h2.toString(16).padStart(8, '0')}`;
  return combined.repeat(Math.ceil(hexLen / combined.length)).slice(0, hexLen);
}

/** Stable operation document ID under source project scope. */
export function computeSequelOperationId(input: SequelIdentityInput): string {
  const material = [
    input.ownerUid,
    input.sourceProjectId,
    String(input.targetVolume),
    input.seriesId || '',
  ].join('|');
  return `seqop_${stableDigest(material, 20)}`;
}

/** Stable target project document ID — one Volume N stub per owner + series. */
export function computeSequelTargetProjectId(input: {
  ownerUid: string;
  seriesId: string;
  targetVolume: number;
}): string {
  const material = [input.ownerUid, input.seriesId, String(input.targetVolume)].join('|');
  return `seq_${stableDigest(material, 16)}`;
}
